<template>
  <div class="page flex column">
    <app-header class="flex0" title="在线医生">
      <i slot="back" class="back"></i>
      <router-link tag="div" to="/my/consult/all" slot="right" class="right absolute">我的咨询</router-link>
    </app-header>
    <div class="search flex0 pt10 pb10 bg_white">
      <router-link :to="{path:'/v2/search',query:$route.query}" tag="div" class="radius15 color_999 pl15">
        <font class="iconfont">&#xe60c;</font> <span>搜索科室、医生、擅长</span>
      </router-link>
    </div>
    <v-scroll class="flex1" @scroll="scroll1" @scrollEnd="scrollEnd1" ref="scroll">
      <div class="hot bg_white">
        <h4 class="center pt10 pb10">
          <font class="iconfont">&#xe606;</font>
          <span class="fs13 color_333">热门科室</span>
        </h4>
        <ul class="flex pt10 pb10">
          <li v-for="(o,i) in depts" class="flex0 center"
              :class="['item'+depts.length,
              depts.length>8&&depts.length<=10&&i>=5?'mt10':'',
              depts.length>6&&depts.length<=8&&i>=4?'mt10':'',
              depts.length===6&&i>=3?'mt10':'',
              depts.length>4&&depts.length<=5&&i>=5?'mt10':'']"
              @click="handler('dept',o)">
            <div class="icon">
              <img :src="o.deptAvatar||require('../../../../static/img/default.png')" alt="" @error="__deptError">
            </div>
            <div class="text color_333 fs14 ellipsis">{{ o.deptName }}</div>
          </li>
        </ul>
      </div>
      <div class="posline" id="posline"></div>
      <consult-filter ref="sxk" @change="change" :form="originSXK" class="l0 r0" style="z-index: 100;"></consult-filter>
      <ul class="bg_white bt" ref="wrapbox">
        <div class="iconfont nodata center fs100 color_999" v-if="list.length===0">&#xe60a;</div>
        <doc-item :info="o" :key="i" v-for="(o,i) in list"></doc-item>
      </ul>
    </v-scroll>

  </div>
</template>
<script>
import Filter from '../../../plugins/consult/filter'
import Scroll from '../../../plugins/scroll'
import DocItem from '../../../plugins/consult/doc-item-v2.vue'
import ConsultFilter from "../../../plugins/consult/consult-filter";
import VScroll from "../../../plugins/v-scroll";
import {avaErrorMixin} from "@/lib/mixin";
import {find_doc_form_cache_key} from "@/lib/config";
import {isEmpty} from '@/lib/util'
import {fromPageCache} from "@/lib/cache";
import {systemService} from "@/services/system";

export default {
  props: ['status', 'message', 'consult'],
  data() {
    return {
      showSxk: false,
      page: 1,
      from: "",
      depts: [],
      form: {}, list: [],
      originSXK: []
    };
  },
  computed: {},
  components: {VScroll, ConsultFilter, VFilter: Filter, Scroll, DocItem},
  mixins: [avaErrorMixin],
  beforeRouteEnter(to, from, next) {
    fromPageCache.set(from.path)
    next()
  },
  async mounted() {
    const cache = this.$cache.get(find_doc_form_cache_key);
    const {deptCode} = this.$route.query;
    if (!isEmpty(cache) && fromPageCache.get() === '/doc/index') {
      await this.getDept();
      this.originSXK = cache;
    } else if (this.get.bookDeptName === 'rxwk') {
      await this.getDept();
      await this.getGbdeptList('deptName', '乳腺外科')
    } else if (this.get.bookDeptName === 'nfmk') {
      await this.getDept();
      await this.getGbdeptList('deptName', '内分泌')
    } else if (this.get.bookDeptName === 'pwk') { // 普外科||普通外科
      await this.getDept();
      await this.getGbdeptList('deptName', '普外科')
    } else if (deptCode) {
      await this.getDept();
      await this.getGbdeptList('deptCode', deptCode)
    } else {
      await this.getList();
      await this.getDept();
    }
    this.initWrapHeight();
  },
  beforeDestroy() {
    this.$cache.set(find_doc_form_cache_key, this.originSXK);
  },
  methods: {
    async getGbdeptList(type, val) {
      let list = await systemService.gbdeptList();
      list = list.reduce((t, v) => {
        return v.sonGbDeptList && t.concat(v.sonGbDeptList) || t;
      }, [])
      let dept = {
        "id": "dept",
        "name": '全部科室',
        "value": '00',
        "old": '全部科室'
      };


      function getDept(type, val) {
        if (type === 'deptCode') {
          for (let i = 0; i < list.length; i++) {
            let r = list[i];
            if (val === r.gbDeptCode) {
              dept = {
                "id": "dept",
                "name": r.gbDeptName,
                "value": r.gbDeptCode,
                "old": r.gbDeptName
              };
              return dept;
            }
          }
        } else if (type === 'deptName') {
          for (let i = 0; i < list.length; i++) {
            let r = list[i];
            const testIn = () => {
              if (val === '普外科') return r.gbDeptName.indexOf(val) >= 0 || r.gbDeptName.indexOf('普通外科') >= 0
              return r.gbDeptName.indexOf(val) >= 0
            };
            if (testIn()) {
              dept = {
                "id": "dept",
                "name": r.gbDeptName,
                "value": r.gbDeptCode,
                "old": r.gbDeptName
              };
              return dept;
            }
          }
        }
      }

      if (getDept(type, val)) {
        dept = getDept(type, val);
      }

      this.originSXK = [{"id": "hos", "name": "全部医院", "old": "全部医院"}, dept, {
        "id": "type",
        "name": "全部形式",
        "old": "全部形式"
      }, {"id": "sort", "name": "默认排序", "old": "默认排序"}]
    },

    initWrapHeight() {
      let wrapbox = this.$refs.wrapbox;
      if (!wrapbox) {
        setTimeout(this.initWrapHeight, 20);
      } else {
        const h = Math.min(window.innerHeight, screen.availHeight);
        wrapbox.style.minHeight = `${h - 45 - 50 - 45}px`;
      }
    },

    handler(type, data) {
      switch (type) {
        case "dept":
          this.$refs.sxk.setSxk({
            id: 'dept',
            name: data.deptName,
            value: data.deptCode
          });
          //this.scrollToSxk(300);
          break;
      }
    },

    async getDept() {
      let loading = this.$weuijs.loading("加载中...");
      let {code, list} = await this.$http("nethos.system.hotstddept.list", {});
      code == 0 && (this.depts = list);
      loading.hide();
    },

    async change(data) {
      this.originSXK = data;
      data.forEach(r => {
        if (r.value) {
          this.$set(this.form, r.id, r.value);
        }
        if (['type', 'sort'].includes(r.id) && !r.value) {
          delete this.form[r.id];
        }
      });
      this.page = 1;
      this.list = [];
      await this.getList('toSxk');
    },

    scrollToSxk(time) {
      let posline = document.getElementById('posline'),
        scrollCom = this.$refs.scroll.$el,
        searchEl = document.getElementsByClassName('search')[0];
      let searchHeight = searchEl.getBoundingClientRect().height;
      let currTop = posline.getBoundingClientRect().top;
      Log('pos', searchHeight + 45, currTop)
      if (Math.abs(currTop - searchHeight - 45) > 1)
        scrollCom.scrollTop = currTop - searchHeight - 45;
    },

    watchSxkPos() {
      let sxkEl = this.$refs.sxk.$el;
      if (sxkEl) {
        let pos = sxkEl.getBoundingClientRect();
        if (pos.top < 95) this.showSxk = true;
        else this.showSxk = false;
      }
    },

    scroll(pos) {
      let sxkEl = this.$refs.sxk.$el;
      if (sxkEl) {
        let posEl = sxkEl.getBoundingClientRect();
        if (posEl.top <= 95) {
          this.showSxk = true;
        } else this.showSxk = false;
      }
    },

    scroll1(pos) {
      let sxkEl = this.$refs.sxk.$el,
        posline = document.getElementById('posline');
      if (sxkEl) {
        let posEl = posline.getBoundingClientRect();
        if (posEl.top <= 95) {
          posline.style.height = sxkEl.clientHeight + 'px';
          sxkEl.classList.add('fixed');
        } else {
          posline.style.height = '0px';
          sxkEl.classList.remove('fixed');
        }
      }
    },

    scrollToEnd() {
      if (this.next) {
        this.page++;
        this.getList();
      }
    },

    scrollEnd1() {
      if (this.next) {
        this.page++;
        this.getList();
      }
    },
    async getList(handler) {
      let {form, get} = this;
      let {subDeptName} = this.$route.query;

      Log('form', {...form});


      let options = {
        pageSize: subDeptName ? 1000 : 10,
        pageNum: this.page
      };

      if (form.hos) {
        options.hosId = form.hos;
      }

      if (form.dept && form.dept != '00') {
        options.gbDeptCode = form.dept;
      }

      if (form.type) {
        options[form.type] = true;
      }

      if (form.sort) {
        if (form.sort === 'recommendSort') {
          options.sort = `${form.sort}.asc`;
          options.isRecommend = true;
        } else if (form.sort === 'famousSort') {
          options.sort = `${form.sort}.asc`;
        } else options.sort = `${form.sort}.desc`;
      }


      let loading = this.$weuijs.loading("加载中...");
      let {code, list, paginator} = await this.$http('nethos.doc.list', options);
      loading.hide();

      if (subDeptName) {
        list = list.filter(r => r.docDeptName === subDeptName);
      }


      if (code == 0) {
        this.list = this.list.concat(list);
        this.next = paginator.hasNextPage;

        setTimeout(() => {
          handler === 'toSxk' && this.scrollToSxk();
        }, 300);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../common/public";

.page {
  flex-direction: column;
}

.search {
  @include border(bottom);

  div {
    line-height: 30px;
    margin: 0 auto;
    @include w_h(px2rem(355px), 30px);
    background-color: #f2f5f9;
  }
}

.hot {
  @include border(bottom);

  font {
    color: #de4748;
  }

  ul {
    flex-wrap: wrap;
  }

  li {
    .icon {
      img {
        border-radius: 50%;
      }
    }

    &.item6 {
      img {
        @include w_h(3.3rem, 3.3rem);
      }
    }
  }
}

.item4, .item8 {
  width: (100% / 4);

  img {
    @include w_h(2.4rem, 2.4rem);
  }
}

.item5, .item10 {
  width: (100% / 5);

  img {
    @include w_h(1.92rem, 1.92rem);
  }
}

.item6 {
  width: (100% / 3);
}

.fixed {
  top: 95px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/onlineDoctor/internetRoom.vue